// removed by extract-text-webpack-plugin
module.exports = {"item":"_1EgO"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col3Text/Col3Text.scss
// module id = PchY
// module chunks = 0